/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OpenBuyerOrderDTOFromJSON, OpenBuyerOrderDTOToJSON, } from './OpenBuyerOrderDTO';
/**
 * Check if a given object implements the OpenBuyerOrdersResponse interface.
 */
export function instanceOfOpenBuyerOrdersResponse(value) {
    return true;
}
export function OpenBuyerOrdersResponseFromJSON(json) {
    return OpenBuyerOrdersResponseFromJSONTyped(json, false);
}
export function OpenBuyerOrdersResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orders': json['orders'] == null ? undefined : (json['orders'].map(OpenBuyerOrderDTOFromJSON)),
    };
}
export function OpenBuyerOrdersResponseToJSON(json) {
    return OpenBuyerOrdersResponseToJSONTyped(json, false);
}
export function OpenBuyerOrdersResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orders': value['orders'] == null ? undefined : (value['orders'].map(OpenBuyerOrderDTOToJSON)),
    };
}
